import { useEffect, useRef } from 'react';
import { Player, type PlayerRef } from '@remotion/player';
import { ThemeTransitionComposition } from '../../remotion/ThemeTransitionComposition';
import { useReducedMotion } from '../../hooks/useReducedMotion';

const FPS = 60;
const DURATION = 48; // 0.8s

interface ThemeTransitionOverlayProps {
  trigger: number; // increment to trigger the animation
}

export function ThemeTransitionOverlay({ trigger }: ThemeTransitionOverlayProps) {
  const playerRef = useRef<PlayerRef>(null);
  const reducedMotion = useReducedMotion();

  useEffect(() => {
    if (trigger === 0 || reducedMotion) return;
    const player = playerRef.current;
    if (!player) return;
    player.seekTo(0);
    player.play();
  }, [trigger, reducedMotion]);

  if (reducedMotion) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        pointerEvents: 'none',
      }}
      aria-hidden="true"
    >
      <Player
        ref={playerRef}
        component={ThemeTransitionComposition}
        compositionWidth={1920}
        compositionHeight={1080}
        fps={FPS}
        durationInFrames={DURATION}
        controls={false}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
}
